<template>
  <b-container fluid>
      <div v-if="filteredPatients">
        <div class="iq-search-bar mb-4 ml-auto">
        <div class="searchbox">
          <input type="text" class="text search-input" placeholder="Search" v-model="searchInput">
          <span class="search-link"><i class="ri-search-line"></i></span>
        </div>
      </div>
      <div v-if="filteredPatients.length">
      <b-row>
      <b-col sm="12" md="3" v-for="patient in patientsForEachPage" :key="patient.id" class="mb-4">
          <iq-card body-class="text-center" class="h-100 mb-1">
            <template v-slot:default>
              <div class="doc-profile">
                <img v-if="patient.profilePic" class="rounded-circle img-fluid avatar-80" :src="patient.profilePic" alt="profile">
                <img v-else src="../../assets/images/page-img/48.png" alt="profile-img" class="rounded-circle img-fluid avatar-80">
              </div>
              <div class="iq-doc-info mt-3 ml-2">
                <h4> {{ patient.firstName }} {{ patient.lastName }}</h4>
                <p class="mb-3" >{{ patient.email }}</p>
              </div>
              <button @click="toPatientProfile(patient.id)" class="btn btn-primary ml-2">View Profile</button>
            </template>
          </iq-card>
      </b-col>
    </b-row>
    <div style="overflow-x:auto">
          <b-pagination pills :hide-goto-end-buttons="false" :per-page="perPage"
            v-model="currentPage" :total-rows="filteredPatients.length" class="pagination"></b-pagination>
            <div class="page-control mt-3 mb-4">
                Per Page
                <select v-model="perPage" class="select">
                  <option value=8>8</option>
                  <option value=16>16</option>
                  <option value=32>32</option>
                </select>
                Showing {{ start }} to {{ end }} of {{ total }}
            </div>
    </div>
  </div>
      </div>
      <iq-card v-else>
        <el-empty description="No patients found with your registered devices.">
        Add devices
      <router-link to="/profile" class="link">here</router-link>.
        </el-empty>
      </iq-card>
  </b-container>
</template>
<script>
import { xray } from '../../config/pluginInit'
import getCollection from '../../services/getCollection'
import getDocument from '../../services/getDocument'
import { ref, watch, computed, watchEffect } from 'vue'
import { useRouter } from 'vue-router'
import firebase from '../../../firebase'
import iqCard from '../../components/xray/cards/iq-card.vue'

export default {
  components: { iqCard },
  name: 'UserList',
  mounted () {
    xray.index()
  },
  setup () {
    const { documents: patients } = getCollection('users')
    const firebaseDoctor = firebase.firebaseAuth.currentUser
    const { document: doctor } = getDocument('doctors', firebaseDoctor.uid)

    const searchInput = ref(null)
    const patientsForEachPage = ref(null)
    const perPage = ref(16)
    const currentPage = ref(1)
    const filteredPatients = ref(null)

    const start = computed(() => {
      return Number((currentPage.value - 1)) * Number(perPage.value) + 1
    })

    const end = computed(() => {
      if (Number(start.value) + Number(perPage.value) - 1 > filteredPatients.value.length) {
        return filteredPatients.value.length
      }
      return Number(start.value) + Number(perPage.value) - 1
    })

    const total = ref(null)

    watch(perPage, () => {
      currentPage.value = 1
    })

    const sortPatientsByName = (a, b) => {
      const nameA = a.lastName.toUpperCase()
      const nameB = b.lastName.toUpperCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    }

    watchEffect(() => {
      if (!doctor.value || !doctor.value.devices || !doctor.value.devices.length) {
        filteredPatients.value = null
        patientsForEachPage.value = null
        return
      }
      if (patients.value) {
        const patientsArray = patients.value.filter(patient => {
          if (!patient.devices) {
            return false
          }

          const overlap = Object.keys(patient.devices).some(key => doctor.value.devices.includes(key))

          return patient.lastName !== undefined && patient.firstName !== undefined && overlap
        })

        if (!searchInput.value || !searchInput.value.length) {
          filteredPatients.value = patientsArray
        } else {
          currentPage.value = 1
          filteredPatients.value = patientsArray.filter(patient => {
            return patient.firstName.toLowerCase().includes(searchInput.value.toLowerCase()) ||
            patient.lastName.toLowerCase().includes(searchInput.value.toLowerCase()) ||
            patient.email.toLowerCase().includes(searchInput.value.toLowerCase())
          })
        }

        filteredPatients.value = filteredPatients.value.sort(sortPatientsByName)
        total.value = filteredPatients.value.length

        const start = Number((currentPage.value - 1)) * Number(perPage.value)
        const end = start + Number(perPage.value)
        patientsForEachPage.value = filteredPatients.value.slice(start, end)
      }
    })

    const router = useRouter()
    const toPatientProfile = (uid) => {
      router.push({ name: 'patients.patientDashboard', params: { uid: uid } })
    }

    return {
      searchInput,
      patientsForEachPage,
      perPage,
      currentPage,
      filteredPatients,
      start,
      end,
      total,
      toPatientProfile
    }
  }
}
</script>

<style scoped>
    .pagination {
      padding: 10px 15px;
      display: inline-flex;
    }

    .page-control {
      margin: 10px 5px 0 15px;
      padding: 0 10px;
      display: inline-block;
      float: right;
    }

    .select {
      margin-left: 10px;
      margin-right: 10px;
      padding: 0 10px;
    }

    .iq-doc-info {
      word-wrap: break-word;
    }

    .iq-search-bar {
      width: 30%;
    }

    .searchbox {
      width: 100% !important;
    }
</style>

<style>

.pagination li {
  padding: 5px;
}

</style>
